module.exports = __webpack_public_path__ + "static/media/fees.5d8e32b3.svg";